<template>
  <div class="product-wechat-group-info">
    <ym-popup class="product-wechat-group-info-popup"
              v-ym-report:JOIN_GROUP_POPUP_EXPOSURE="popupExposure"
              v-model="visible"
              :close-on-click-overlay="false"
              get-container="body"
    >
      <div v-if="product"
           class="product-wechat-group-info-container"
           @click="handleShowToast"
      >
        <div class="product-wechat-group-info-header">
          <div v-if="userInfo && userInfo.name !== ''"
               class="product-wechat-group-info-header-user-info"
          >
            <span class="name">{{ userInfo.name }} 同学</span><span>欢迎你加入：</span>
          </div>
          <div v-if="product && product.title !== ''"
               class="product-wechat-group-info-header-course-info"
          >
            {{ product.title }}
          </div>
          <div v-if="product && product.timeDesc !== ''"
               class="product-wechat-group-info-header-date-info"
          >
            {{ product.timeDesc }}
          </div>
          <ym-img class="deco"
                  :src="require('@/assets/img/combo/wechat_group_deco.png')"
          />
        </div>
        <div v-if="groupInfo"
             class="product-wechat-group-info-content"
        >
          <div v-if="groupInfo.title && groupInfo.title !== ''"
               class="product-wechat-group-info-content-title"
          >
            <ym-img class="icon"
                    :src="require('@/assets/img/combo/wechat_group_title_icon.png')"
            />
            <span>{{ groupInfo.title }}</span>
          </div>
          <div v-if="groupInfo.desc && groupInfo.desc !== ''"
               class="product-wechat-group-info-content-desc"
               v-html="groupInfo.desc"
          ></div>
          <div v-if="groupInfo.keyword && groupInfo.keyword !== ''"
               class="product-wechat-group-info-content-keyword"
          >
            <span class="product-wechat-group-info-content-keyword-text"
                  id="groupKeyword"
            >
              {{ groupInfo.keyword }}
            </span>
            <div class="product-wechat-group-info-content-keyword-btn copy-btn"
                 data-clipboard-action="copy"
                 data-clipboard-target="#groupKeyword"
                 @click="handleCopy"
            >
              复制
            </div>
          </div>
          <template v-if="!inAppWebView && qrCode && qrCode.src !== ''">
            <div class="product-wechat-group-info-content-tip">
              <template v-if="groupInfo.keyword !== ''">
                复制后扫码，<span>回复</span>关键字即可进群
              </template>
              <template v-else>
                立即扫码进群
              </template>
            </div>
            <div class="product-wechat-group-info-content-qr-code"
                 v-ym-report:JOIN_GROUP_QRCODE_CLICK="{
                targetId: product.id, targetType: product.type, type: 'h5'
               }"
            >
              <ym-img class="img"
                      :src="qrCode.src"
              />
            </div>
          </template>
          <div v-if="inAppWebView && qrCode && qrCode.src !== ''"
               class="product-wechat-group-info-content-app-qr-code copy-btn"
               data-clipboard-action="copy"
               data-clipboard-target="#groupKeyword"
               @click.self.stop="handleAppScanCode"
               v-ym-report:JOIN_GROUP_QRCODE_CLICK="{
                targetId: product.id, targetType: product.type, type: 'webview'
               }"
          >
            {{ groupInfo.keyword === '' ? '' : '已复制，' }}去扫码进群
          </div>
          <div class="product-wechat-group-info-content-action"
               @click.self.stop="recordJoinWeChatGroup(product.id, product.type)"
               v-ym-report:JOIN_GROUP_JOINED_CLICK="{
                 targetId: product.id, targetType: product.type
               }"
          >
            我已进群
          </div>
        </div>
      </div>
    </ym-popup>
  </div>
</template>

<script>
  import ClipboardJS from 'clipboard';
  import { Popup } from '@ymba/ym-ui';
  import validator from '@/utils/validator';
  import { recordJoinWeChatGroup } from '@/services/app';
  import { isAppWebView } from '@/utils';
  import { locationToAppWithRoute } from '@/utils/app-route';

  export default {
    name: 'ProductWechatGroupInfo',
    components: {
      'ym-popup': Popup,
    },
    props: {
      show: {
        type: Boolean,
        required: true,
      },
      product: {
        validator(val) {
          return validator.isObject(val);
        },
      },
      userInfo: {
        validator(val) {
          return validator.isObject(val);
        },
      },
    },
    data() {
      return {
        visible: false,
      };
    },
    computed: {
      popupExposure() {
        if (this.product == null) return {};
        return { targetId: this.product.id, targetType: this.product.type };
      },
      groupInfo() {
        if (this.product == null) return null;
        return this.product.groupInfo || null;
      },
      qrCode() {
        if (this.product == null) return null;
        return this.product.groupInfo.qrCode || null;
      },
      inAppWebView() {
        return isAppWebView();
      },
    },
    watch: {
      show(val) {
        this.visible = val;
      },
      visible(val) {
        this.$emit('update:show', val);
      },
    },
    methods: {
      handleCopy() {
        const clipboard = new ClipboardJS('.copy-btn');
        clipboard.on('success', (e) => {
          this.$toast('内容已复制到剪切板');
          e.clearSelection();
        });
        clipboard.on('error', () => {
          this.$toast('复制失败，请手动复制');
        });
      },
      handleShowToast() {
        this.$toast('请先完成进群操作');
      },
      async recordJoinWeChatGroup(id, type) {
        await recordJoinWeChatGroup(id, type);
        this.visible = false;
      },
      handleAppScanCode() {
        if (this.groupInfo.keyword === '') {
          const { src, hint } = this.qrCode;
          locationToAppWithRoute({ name: 'AppQrCodeDetail', params: { qrCode: src, hint } });
          return;
        }
        const clipboard = new ClipboardJS('.copy-btn');
        clipboard.on('success', (e) => {
          this.$toast('内容已复制到剪切板');
          const { src, hint } = this.qrCode;
          locationToAppWithRoute({ name: 'AppQrCodeDetail', params: { qrCode: src, hint } });
          e.clearSelection();
        });
        clipboard.on('error', () => {
          this.$toast('复制失败，请手动复制');
        });
      },
    },
  };
</script>

<style scoped lang="less">
  @import '~@/assets/styles/var.less';

  .product-wechat-group-info {
    &-popup {
      width: 100%;
      height: 100%;
      background: @color-white;
    }

    &-container {
      box-sizing: border-box;
      width: 100%;
      height: 100%;
    }
    &-header {
      position: relative;
      box-sizing: border-box;
      width: 100%;
      height: 352px;
      padding: 84px 0 0 50px;
      color: @color-white;
      font-size: @font-size-medium;
      background: linear-gradient(to bottom, @color-primary-aide, @color-primary);

      .deco {
        position: absolute;
        top: 26px;
        right: 30px;
        width: 360px;
        height: 278px;
      }
    }
    &-header-user-info {
      margin-bottom: @size-small;
      display: flex;
      align-items: flex-end;
      line-height: 1;
      .name {
        margin-right: 25px;
        font-size: @font-size-extra-extra-large;
        font-weight: @font-weight-bold;
      }
    }
    &-header-course-info {
      margin-bottom: @size-extra-small;
    }

    &-content {
      position: relative;
      z-index: @z-index-large;
      margin-top: -@size-extra-medium;
      width: 100%;
      display: flex;
      flex-direction: column;
      align-items: center;
      background: @color-white;
      border-radius: 18px 18px 0 0;
    }
    &-content-title {
      position: relative;
      box-sizing: border-box;
      margin-top: @size-large;
      margin-bottom: @size-large;
      padding: @size-extra-small 14px;
      display: flex;
      align-items: flex-end;
      color: @color-text-base;
      font-size: @font-size-largest;
      font-weight: @font-weight-heavy;
      line-height: 1;
      &:after {
        position: absolute;
        left: 0;
        bottom: 0;
        content: '';
        width: 100%;
        height: @size-small;
        background: #e9f7f7;
        border-radius: 10px;
      }
      span {
        position: relative;
        z-index: @z-index-large;
      }
      .icon {
        position: relative;
        z-index: @z-index-large;
        margin-right: @size-small;
        width: 50px;
        height: 55px;
      }
    }
    &-content-desc {
      margin-bottom: @size-base;
      color: @color-text-base;
      font-size: @font-size-medium;
      line-height: 1.5;
      text-align: center;
    }
    &-content-keyword {
      margin-bottom: @size-medium;
      display: flex;
      align-items: center;
      justify-content: center;

      &-text {
        box-sizing: border-box;
        height: 70px;
        padding: 0 35px;
        display: flex;
        align-items: center;
        justify-content: center;
        color: @color-text-base;
        font-size: @font-size-large;
        font-weight: @font-weight-bold;
        border: 1px solid #ccc;
        border-right: none;
        border-radius: 8px 0 0 8px;
      }
      &-btn {
        width: 150px;
        height: 70px;
        margin-left: -@size-extra-small;
        display: flex;
        align-items: center;
        justify-content: center;
        color: @color-white;
        background: @color-primary;
        border-radius: 8px;
      }
    }
    &-content-tip {
      margin-bottom: @size-base;
      color: @color-text-base;
      font-size: @font-size-medium;
      line-height: 1;
      span {
        color: @color-primary-aide;
      }
    }
    &-content-qr-code {
      box-sizing: border-box;
      margin-bottom: @size-base;
      width: 200px;
      height: 200px;
      padding: @size-extra-small;
      background: #e9f7f7;
      border-radius: 8px;
      .img {
        position: relative;
        width: 100%;
        height: 100%;
        z-index: @z-index-large;
      }
    }
    &-content-app-qr-code {
      margin-top: 130px;
      margin-bottom: @size-medium;
      width: 420px;
      height: 100px;
      display: flex;
      align-items: center;
      justify-content: center;
      color: @color-white;
      font-size: @font-size-medium;
      line-height: 1;
      background: @color-primary;
      border-radius: 55px;
    }
    &-content-action {
      width: 420px;
      height: 100px;
      display: flex;
      align-items: center;
      justify-content: center;
      color: @color-primary-aide;
      font-size: @font-size-medium;
      background: @color-white;
      border: 1px solid @color-primary-aide;
      border-radius: 55px;
    }
  }

</style>
